
import AppStagingBanner from "./AppStagingBanner.vue"
import AppButton from "./AppButton"
import AppLink from "./AppLink.vue"
import NavLink from "./NavLink.vue"
import stubDirectives from "../mixins/stubDirectives"
import preventScrollMixin from "./../mixins/preventScrollMixin"

import renewalStatusHelper from "../helpers/renewalStatusHelper"

export default {
  components: {
    AppStagingBanner,
    AppButton,
    AppLink,
    NavLink
  },
  mixins: [stubDirectives, preventScrollMixin],
  props: {
    nav: {
      type: Array,
      default: () => []
    },
    logInLink: {
      type: Object,
      default: () => {}
    },
    signOutLink: {
      type: Object,
      default: () => {}
    },
    accountNumber: {
      type: String,
      default: ""
    },
    user: {
      type: Object,
      default: () => ({})
    },
    userStatus: {
      type: Object,
      default: () => {}
    },
    logoImage: {
      type: Object,
      default: () => {}
    },
    hideMenu: {
      type: Boolean,
      default: false
    },
    hideNavMenu: {
      type: Boolean,
      default: false
    },
    trackingClickGroup: {
      type: [Array, Object],
      default: null
    },
    isProspectSwitchJourneyEnabled: {
      type: Boolean,
      default: false
    },
    isPromoteRenewalEnabled: {
      type: Boolean,
      default: true
    },
    deploymentUrl: {
      type: String,
      default: null
    },
    moveOutRecordFetched: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      AppButton,
      submenu: [],
      submenuSelected: "",
      mobileNavOpen: false,
      dropdownMenuActive: "",
      timer: null
    }
  },
  computed: {
    isStagingPreview() {
      return this.deploymentUrl?.includes("staging")
    },
    filteredNav() {
      if (!this.nav) return []
      return this.nav
        .filter(navTitle => this.filterNavTitle(navTitle))
        .filter(navTitle => !!!navTitle.showAsButton)
        .map((navMenu, _uid) => {
          return {
            navTitle: navMenu.navTitle,
            navLinks: navMenu.navLinks.filter(navLink =>
              this.checkAccountRoute(navLink.link)
            ),
            backgroundColor: navMenu.backgroundColor,
            fontColor: navMenu.fontColor,
            _editable: navMenu._editable,
            _uid
          }
        })
    },
    mobileNavLinks() {
      if (this.submenuSelected) {
        return this.filteredNav.find(
          element => element.navTitle[0].name == this.submenuSelected
        ).navLinks
      } else {
        return this.filteredNav.map(link => link.navTitle[0])
      }
    },
    filteredNavButtons() {
      if (!this.nav) return []
      return this.nav
        .filter(navTitle => this.filterNavTitle(navTitle))
        .filter(navTitle => navTitle.showAsButton)
        .map((navMenu, _uid) => {
          return {
            navTitle: navMenu.navTitle,
            _uid
          }
        })
    },
    logoSrc() {
      if (this.logoImage && this.logoImage.filename) {
        return this.logoImage.filename
      }
      return require(`../images/logo-so-energy-black.svg`)
    },
    logoAltText() {
      if (this.logoImage && this.logoImage.alt) {
        return this.logoImage.alt
      }
      return "So Energy logo"
    }
  },
  watch: {
    mobileNavOpen: {
      handler(value) {
        this.preventBodyScroll(value)
      }
    }
  },
  methods: {
    filterNavTitle(route) {
      let showNavTile = this.userStatus.userSignedIn
        ? !route.hideWhenLoggedIn
        : !route.hideWhenLoggedOut

      const validLink =
        route.navTitle && route.navTitle[0] && route.navTitle[0].link

      if (
        !this.isProspectSwitchJourneyEnabled &&
        validLink &&
        route.navTitle[0].link === "/get-a-quote"
      ) {
        showNavTile = false
      }

      if (
        this.moveOutRecordFetched &&
        validLink &&
        route.navTitle[0].link === "/moving-home"
      ) {
        showNavTile = false
      }

      if (
        !this.moveOutRecordFetched &&
        validLink &&
        route.navTitle[0].link === "/move-out/status"
      ) {
        showNavTile = false
      }

      return showNavTile
    },
    checkAccountRoute(route) {
      const user = this.userStatus

      switch (route) {
        case "/accounts/renew":
        case "/renew":
          return (
            this.isPromoteRenewalEnabled &&
            user.accountCanRenew &&
            !user.onVariableContract &&
            !renewalStatusHelper.hasPendingRenewal(
              this.user,
              this.accountNumber
            )
          )
        case "/accounts/renew?fixed-contract":
        case "/renew?fixed-contract":
          return (
            this.isPromoteRenewalEnabled &&
            user.accountCanRenew &&
            user.onVariableContract &&
            !renewalStatusHelper.hasPendingRenewal(
              this.user,
              this.accountNumber
            )
          )
        case "/accounts/balance":
        case "/balance":
          return user.accountUnlocked
        case "/accounts/readings":
        case "/readings":
          return !user.accountRestricted && user.accountUnlocked
        case "/accounts/usage":
        case "/usage":
          return !user.accountRestricted && user.accountUnlocked
        case "/accounts/edit":
        case "/personal-details":
          return true
        case "/accounts/tariff-information":
        case "/tariff":
          return !user.accountRestricted
        case "/accounts/payments":
        case "/payments":
          return !user.accountRestricted && user.accountUnlocked
        case "/accounts/refer":
        case "/refer":
          return !user.blacklistedVoucher && !user.referDisabledGlobally
        case "/accounts/change":
        case "/choose":
          return user.multipleAccounts
        case "/accounts/smart_meter_portal":
          return (
            user.eligibleForSmartMeter && user.eligibleForSmartMeter.eligible
          )
        default:
          return true
      }
    },
    toggleMobileMenu() {
      this.mobileNavOpen = !this.mobileNavOpen
      this.submenuSelected = ""
    },
    clickMobileNav(submenu, closeMenu) {
      this.submenuSelected = submenu
    },
    desktopNavItemClicked() {
      setTimeout(() => {
        this.dropdownMenuActive = ""
      }, 200)
    },
    mobileNavItemClicked() {
      setTimeout(() => {
        this.mobileNavOpen = false
      }, 300)
    },
    clickBack() {
      this.submenuSelected = ""
    },
    hoverNav(dropdown) {
      clearTimeout(this.timer)
      this.dropdownMenuActive = dropdown
    },
    leaveNav() {
      this.timer = setTimeout(() => {
        this.dropdownMenuActive = ""
      }, 500)
    },
    openDropdown(dropdown) {
      if (this.dropdownMenuActive) {
        this.dropdownMenuActive = ""
      } else {
        this.dropdownMenuActive = dropdown
      }
    },
    kebabCase(name) {
      return name
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase()
    }
  }
}
